import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/auth";
import AppShell from "./components/AppShell";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import NewMeeting from "./pages/NewMeeting";
import Meeting from "./pages/Meeting";
import MeetingMinutes from "./pages/MeetingMinutes";
import MeetingHistory from "./pages/MeetingHistory";
import MeetingTrash from "./pages/MeetingTrash";
import Goals from "./pages/Goals";
import JoinInvite from "./pages/JoinInvite";
import Calendar from "./pages/Calendar";
import LiveJoin from "./pages/LiveJoin";
import Pricing from "./pages/Pricing";
import BillingReturn from "./pages/BillingReturn";
import Referrals from "./pages/Referrals";
import Founders from "./pages/Founders";
import SampleMinutes from "./pages/SampleMinutes";
import AuthCallback from "./pages/AuthCallback";
import AdminOrphans from "./pages/AdminOrphans";
import AdminUsers from "./pages/AdminUsers";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQPage from "./pages/FAQ";
import BoardBook from "./pages/BoardBook";
import Milestones from "./pages/Milestones";
import BoardBooks from "./pages/BoardBooks";
import QuarterReview from "./pages/QuarterReview";
import YearReview from "./pages/YearReview";
import YearReviewPublic from "./pages/YearReviewPublic";
import QuarterReviewPublic from "./pages/QuarterReviewPublic";
import StreakBadgePublic from "./pages/StreakBadgePublic";
import BoardBookPublic from "./pages/BoardBookPublic";

/**
 * Router body — intercepts the auth callback fragment BEFORE any other route
 * renders, avoiding a race between the AuthProvider's /auth/me check and the
 * session_id exchange.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Home />} />
        <Route path="/welcome" element={<Landing />} />
        <Route path="/meetings" element={<MeetingHistory />} />
        <Route path="/meetings/trash" element={<MeetingTrash />} />
        <Route path="/meetings/new" element={<NewMeeting />} />
        <Route path="/meetings/:id/minutes" element={<MeetingMinutes />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/founders" element={<Founders />} />
        <Route path="/admin/orphans" element={<AdminOrphans />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/meetings/:id/board-book" element={<BoardBook />} />
        <Route path="/board-books" element={<BoardBooks />} />
        <Route path="/milestones" element={<Milestones />} />
        <Route path="/quarter-review/:year/:quarter" element={<QuarterReview />} />
        <Route path="/year-review/:year" element={<YearReview />} />
      </Route>
      {/* Full-screen routes (no shell) */}
      <Route path="/meetings/:id" element={<Meeting />} />
      <Route path="/live/:id" element={<LiveJoin />} />
      <Route path="/invite/:token" element={<JoinInvite />} />
      <Route path="/billing/return" element={<BillingReturn />} />
      <Route path="/sample" element={<SampleMinutes />} />
      <Route path="/board-book/:token" element={<BoardBookPublic />} />
      <Route path="/quarter/:token" element={<QuarterReviewPublic />} />
      <Route path="/year/:token" element={<YearReviewPublic />} />
      <Route path="/badge/:token" element={<StreakBadgePublic />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
